module.exports = __webpack_public_path__ + "img/p_icon05.7fe2d653.svg";